import { Flex, type FlexProps } from "@radix-ui/themes";

type StackProps = FlexProps & {
  children: React.ReactNode;
};
export default function Stack({ children, ...props }: StackProps) {
  return (
    <Flex direction={"column"} gap={"2"} {...props}>
      {children}
    </Flex>
  );
}
